import type { SessionUserInfo } from '@/util/authSession';

const NAME_FIELDS = ['firstName', 'middleName', 'lastName'] as const;
const PERSON_FIELDS = ['username', ...NAME_FIELDS, 'city', 'state', 'role'] as const;

function normalizedText(value: unknown): string | null {
	return typeof value === 'string' ? value.trim() || null : null;
}

export function getPostHogPersonProperties(user: SessionUserInfo): Record<string, string | number | null> {
	const properties: Record<string, string | number | null> = {};
	if (typeof user.userNumber === 'number') {
		properties['userNumber'] = user.userNumber;
	}

	// Only send recognizable account details, never the entire profile. Missing
	// fields leave existing properties alone; explicit empty values clear them.
	for (const field of PERSON_FIELDS) {
		if (typeof user[field] === 'string' || user[field] === null) {
			properties[field] = normalizedText(user[field]);
		}
	}

	// The login username is an email address. Older/profile responses can instead
	// supply primaryEmail or email.
	const emailValues = [user.username, user['primaryEmail'], user['email']];
	if (emailValues.some((value) => typeof value === 'string' || value === null)) {
		properties['email'] = emailValues.map(normalizedText).find(Boolean) || null;
	}

	if (NAME_FIELDS.some((field) => field in properties)) {
		properties['name'] =
			NAME_FIELDS.map((field) => normalizedText(user[field]))
				.filter(Boolean)
				.join(' ') || null;
	}

	return properties;
}
